import React, { useRef, useState } from 'react';

const CustomTooltip = (props) => {
    const { children, message } = props;
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const [isVisible, setIsVisible] = useState(false);
    const tooltipRef = useRef(null);

    const showTooltip = (e) => {
        setIsVisible(true);
        updateTooltipPosition(e); // Initial position
    };

    const hideTooltip = () => setIsVisible(false);

    const updateTooltipPosition = (e) => {
        if (!tooltipRef.current) return; 

        const tooltipWidth = tooltipRef.current.offsetWidth ?? 345;
        const tooltipHeight = tooltipRef.current.offsetHeight ?? 100;
        const offset = 15; // Distance from cursor or target

        let x = e.clientX + offset;
        let y = e.clientY + offset;

        // Check if tooltip goes beyond right edge
        if (x + tooltipWidth > window.innerWidth) {
            x = e.clientX - tooltipWidth - offset;
        }

        // Check if tooltip goes beyond bottom edge
        if (y + tooltipHeight > window.innerHeight) {
            y = e.clientY - tooltipHeight - offset;
        }

        setPosition({ top: y, left: x });
    };

    return (
        <div
            className="project-tooltip"
            onMouseEnter={showTooltip}
            onMouseMove={updateTooltipPosition}
            onMouseLeave={hideTooltip}
        >
            {children}
            {isVisible && (
                <div
                    className="project-tooltip-content"
                    ref={tooltipRef}
                    style={{
                        top: `${position.top}px`,
                        left: `${position.left}px`,
                        position: 'fixed',
                        zIndex: 1000 // Ensure tooltip appears on top
                    }}
                >
                    {message?.map((val, index) => (
                        <div className="project-tooltip-content-main" key={index}>
                            {val?.title && <div className="heading">{val?.title}</div>}
                            <div className="d-flex align-items-center gap-2 justify-content-start">
                                {val?.icon && (
                                    <div>
                                        <img src={val?.icon} alt="" width={18} height={18}/>
                                    </div>
                                )}
                                <div className="msg">{val?.msg}</div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomTooltip;
